(() => {
  const WRAPPER_ROOT_SELECTOR = '[data-mm-quick-add]';
  const WRAPPER_SELECTOR = `${WRAPPER_ROOT_SELECTOR}[data-mm-quick-add-has-variants="true"], ${WRAPPER_ROOT_SELECTOR}[data-mm-quick-add-unified="true"]`;
  const TRIGGER_SELECTOR = 'button[data-quick-buy]';
  const MODAL_SELECTOR = '[data-mm-quick-add-modal]';
  const VARIANT_ROW_SELECTOR = '[data-mm-quick-add-variant]';
  const VARIANT_CHECKBOX_SELECTOR = '[data-mm-quick-add-select]';
  const QTY_INPUT_SELECTOR = '[data-mm-quick-add-qty-input]';
  const QTY_MINUS_SELECTOR = '[data-mm-quick-add-qty-minus]';
  const QTY_PLUS_SELECTOR = '[data-mm-quick-add-qty-plus]';
  const PRIMARY_SELECTOR = '[data-mm-quick-add-primary]';
  const CLOSE_SELECTOR = '[data-mm-quick-add-close]';
  const OPEN_ATTR = 'data-mm-quick-add-open';
  const OPEN_WRAPPER_SELECTOR = `${WRAPPER_ROOT_SELECTOR}[${OPEN_ATTR}="true"]`;
  const PREFERRED_MODE_ATTR = 'data-mm-quick-add-preferred-mode';
  const SELECTED_VARIANT_ATTR = 'data-mm-quick-add-selected-variant-id';
  const CART_TARGET_SELECTOR = '[data-mobile-header-cart-btn], .site-header-cart--button, [data-mobile-nav-item="cart"]';
  const FLYING_ITEM_SELECTOR = '[data-flying-item]';
  const FLYING_IMAGE_SELECTOR = '[data-flying-item-image]';
  const QUICK_ADD_TOAST_DURATION = 3500;
  const QTY_HOLD_START_DELAY = 360;
  const QTY_HOLD_REPEAT_DELAY = 86;

  const desktopQuickAddMedia = typeof window.matchMedia === 'function'
    ? window.matchMedia('(min-width: 768px)')
    : null;
  const isDesktopQuickAddViewport = () => desktopQuickAddMedia
    ? desktopQuickAddMedia.matches
    : window.innerWidth > 767;
  const isMobile = () => !isDesktopQuickAddViewport();

  function asElement(target) {
    if (target instanceof Element) return target;
    if (target && target.nodeType === Node.TEXT_NODE) return target.parentElement;
    return null;
  }

  function initializeRandomCartIcons() {}

  function stopHandledClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function isElementVisible(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function getCartTarget() {
    const targets = Array.from(document.querySelectorAll(CART_TARGET_SELECTOR));
    return targets.find(isElementVisible) || targets[0] || null;
  }

  function getSerializedRect(element) {
    if (!element || typeof element.getBoundingClientRect !== 'function') return null;
    const rect = element.getBoundingClientRect();
    if (!rect || (!rect.width && !rect.height)) return null;

    return {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
    };
  }

  async function animateProductToCart({ imageUrl, sourceRect }) {
    const cartTarget = getCartTarget();
    const flyingItem = document.querySelector(FLYING_ITEM_SELECTOR);
    const flyingImage = document.querySelector(FLYING_IMAGE_SELECTOR);

    if (!cartTarget || !flyingItem || !flyingImage || !imageUrl || !sourceRect) {
      return;
    }

    const size = Math.max(58, Math.min(Math.max(sourceRect.width || 0, sourceRect.height || 0), 104));
    const startCenterX = sourceRect.left + ((sourceRect.width || size) / 2);
    const startCenterY = sourceRect.top + ((sourceRect.height || size) / 2);
    const startX = startCenterX - (size / 2);
    const startY = startCenterY - (size / 2);

    const cartRect = cartTarget.getBoundingClientRect();
    const endCenterX = cartRect.left + (cartRect.width / 2);
    const endCenterY = cartRect.top + (cartRect.height / 2);
    const deltaX = endCenterX - startCenterX;
    const deltaY = endCenterY - startCenterY;

    flyingImage.src = imageUrl;
    flyingItem.hidden = false;
    flyingItem.classList.add('flying');
    flyingItem.style.width = `${size}px`;
    flyingItem.style.height = `${size}px`;
    flyingItem.style.left = `${startX}px`;
    flyingItem.style.top = `${startY}px`;
    flyingItem.style.opacity = '1';

    const animation = flyingItem.animate(
      [
        {
          transform: 'translate3d(0, 0, 0) scale(1) rotate(0deg)',
          opacity: 1,
          filter: 'blur(0px)',
        },
        {
          transform: `translate3d(${deltaX * 0.2}px, ${deltaY * 0.14 - 14}px, 0) scale(0.92) rotate(-6deg)`,
          opacity: 0.96,
          filter: 'blur(0px)',
          offset: 0.2,
        },
        {
          transform: `translate3d(${deltaX * 0.66}px, ${deltaY * 0.68 - 28}px, 0) scale(0.46) rotate(12deg)`,
          opacity: 0.84,
          filter: 'blur(0.4px)',
          offset: 0.72,
        },
        {
          transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(0.14) rotate(22deg)`,
          opacity: 0,
          filter: 'blur(1.2px)',
        },
      ],
      {
        duration: 720,
        easing: 'cubic-bezier(0.22, 0.84, 0.18, 1)',
        fill: 'forwards',
      }
    );

    try {
      await animation.finished;
    } catch (error) {
      /* Ignore cancellation if another add-to-cart starts immediately. */
    }

    flyingItem.classList.remove('flying');
    flyingItem.hidden = true;
    flyingItem.style.width = '';
    flyingItem.style.height = '';
    flyingItem.style.left = '';
    flyingItem.style.top = '';
    flyingItem.style.opacity = '';

    cartTarget.classList.remove('bounce');
    void cartTarget.offsetWidth;
    cartTarget.classList.add('bounce');
    setTimeout(() => {
      cartTarget.classList.remove('bounce');
    }, 500);
  }

  function getModal(wrapper) {
    // If modal was moved to body, use stored reference
    if (wrapper && wrapper._mmModalRef) return wrapper._mmModalRef;
    return wrapper ? wrapper.querySelector(MODAL_SELECTOR) : null;
  }

  // Find the wrapper for an element, even if modal was moved to body
  function findWrapper(element) {
    if (!element || typeof element.closest !== 'function') return null;
    const wrapper = element.closest(WRAPPER_ROOT_SELECTOR);
    if (wrapper) return wrapper;
    // Check if inside a body-moved modal
    const modal = element.closest(MODAL_SELECTOR);
    if (modal && modal._mmWrapper) return modal._mmWrapper;
    return null;
  }

  function isInsideQuickAdd(element) {
    if (!element || typeof element.closest !== 'function') return false;
    return !!(element.closest(WRAPPER_ROOT_SELECTOR) || element.closest(MODAL_SELECTOR));
  }

  function getTriggers(wrapper) {
    return wrapper ? Array.from(wrapper.querySelectorAll(TRIGGER_SELECTOR)) : [];
  }

  function isProductCardQuickAdd(wrapper) {
    return !!(wrapper && wrapper.closest('.productitem, .productgrid--item'));
  }

  function getMirroredTriggerButtons(wrapper) {
    if (!isProductCardQuickAdd(wrapper)) return [];
    return getTriggers(wrapper).filter(isElementVisible);
  }

  function getTrigger(wrapper, mode = null) {
    const triggers = getTriggers(wrapper);
    if (!triggers.length) return null;
    if (!mode) return triggers[0];

    return triggers.find(trigger => trigger.getAttribute('data-mm-quick-add-trigger-mode') === mode) || triggers[0];
  }

  function getActiveTrigger(wrapper) {
    const activeTrigger = wrapper?._mmActiveTrigger;
    if (
      activeTrigger
      && activeTrigger.isConnected
      && activeTrigger.closest(WRAPPER_ROOT_SELECTOR) === wrapper
      && isElementVisible(activeTrigger)
    ) {
      return activeTrigger;
    }

    return getTrigger(wrapper, getPreferredMode(wrapper)) || getTrigger(wrapper);
  }

  function getPreferredMode(wrapper) {
    return wrapper?.getAttribute(PREFERRED_MODE_ATTR) || 'cart';
  }

  function getPreferredVariantId(wrapper) {
    if (!wrapper) return '';
    const explicitVariantId = wrapper.getAttribute(SELECTED_VARIANT_ATTR);
    if (explicitVariantId) return explicitVariantId;

    const preferredTrigger = getTrigger(wrapper, getPreferredMode(wrapper));
    const triggerVariantId = preferredTrigger?.getAttribute('data-variant-id');
    if (triggerVariantId) return triggerVariantId;

    const checkedRow = getModal(wrapper)?.querySelector(`${VARIANT_ROW_SELECTOR} ${VARIANT_CHECKBOX_SELECTOR}:checked`);
    return checkedRow?.closest(VARIANT_ROW_SELECTOR)?.getAttribute('data-variant-id') || '';
  }

  function getPrimary(wrapper) {
    if (!wrapper) return null;
    const primary = wrapper.querySelector(PRIMARY_SELECTOR);
    if (primary) return primary;
    // Check in body-moved modal
    const modal = getModal(wrapper);
    if (modal) return modal.querySelector(PRIMARY_SELECTOR);
    return null;
  }

  function getPrimaries(wrapper) {
    if (!wrapper) return [];
    const primaries = wrapper.querySelectorAll(PRIMARY_SELECTOR);
    if (primaries.length > 0) return Array.from(primaries);
    // Check in body-moved modal
    const modal = getModal(wrapper);
    if (modal) return Array.from(modal.querySelectorAll(PRIMARY_SELECTOR));
    return [];
  }

  function syncSinglePrimaryMode(primary, mode) {
    if (!primary) return;

    const normalizedMode = mode === 'buy' ? 'buy' : 'cart';
    const label = primary.querySelector('.mm-quick-add__primary-label');

    if (!primary.dataset.mmQuickAddLabelCart && label) {
      primary.dataset.mmQuickAddLabelCart = label.textContent.trim() || 'Add to Cart';
    }
    if (!primary.dataset.mmQuickAddLabelBuy) {
      primary.dataset.mmQuickAddLabelBuy = 'Buy Now';
    }

    primary.setAttribute('data-mm-quick-add-mode', normalizedMode);
    primary.classList.toggle('mm-quick-add__primary--cart', normalizedMode === 'cart');
    primary.classList.toggle('mm-quick-add__primary--buy', normalizedMode === 'buy');
    primary.hidden = false;
    primary.setAttribute('aria-hidden', 'false');

    if (label) {
      label.textContent = normalizedMode === 'buy'
        ? primary.dataset.mmQuickAddLabelBuy
        : primary.dataset.mmQuickAddLabelCart;
    }
  }

  function clearProcessingState(wrapper) {
    if (!wrapper) return;
    getTriggers(wrapper).forEach(trigger => {
      trigger.classList.remove('processing');
    });
    getPrimaries(wrapper).forEach(primary => {
      primary.classList.remove('processing');
    });
  }

  function setExpanded(wrapper, expanded) {
    const triggers = getTriggers(wrapper);
    if (!triggers.length) return;
    triggers.forEach(trigger => {
      if (trigger.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    });
  }

  function setProductZIndex(wrapper, isRaised) {
    const productItem = wrapper ? wrapper.closest('.productgrid--item') : null;
    if (!productItem) return;
    productItem.style.zIndex = '';
  }

  function isOpen(wrapper) {
    const modal = getModal(wrapper);
    return Boolean(
      wrapper &&
      wrapper.getAttribute(OPEN_ATTR) === 'true' &&
      modal &&
      modal.hidden === false
    );
  }

  function getOpenQuickAddWrapper() {
    return document.querySelector(`${WRAPPER_SELECTOR}[${OPEN_ATTR}="true"]`);
  }

  function close(wrapper, { reset = false } = {}) {
    if (!wrapper) return;
    const modal = getModal(wrapper);
    clearProcessingState(wrapper);
    if (modal) {
      modal.hidden = true;
      // Clear inline styles so [hidden] display:none takes effect
      modal.style.display = '';
      modal.style.visibility = '';
      modal.style.position = '';
      modal.style.top = '';
      modal.style.left = '';
      modal.style.right = '';
      modal.style.bottom = '';
    }
    wrapper.removeAttribute(OPEN_ATTR);
    wrapper._mmActiveTrigger = null;
    setExpanded(wrapper, false);
    setProductZIndex(wrapper, false);

    // Remove mobile backdrop if it exists
    if (wrapper._mmBackdrop) {
      wrapper._mmBackdrop.remove();
      wrapper._mmBackdrop = null;
    }

    // Move modal back from body to original parent
    if (wrapper._mmModalRef && wrapper._mmModalOrigParent) {
      try {
        wrapper._mmModalOrigParent.appendChild(wrapper._mmModalRef);
      } catch (e) { /* ignore if parent was removed */ }
      delete modal._mmWrapper;
      wrapper._mmModalRef = null;
      wrapper._mmModalOrigParent = null;
    }

    if (reset) resetSelections(wrapper);
    syncDesktopViewportListeners();
  }

  function closeAll(exception) {
    document.querySelectorAll(OPEN_WRAPPER_SELECTOR).forEach(wrapper => {
      if (wrapper !== exception) close(wrapper);
    });
  }

  function positionModal(wrapper, modal) {
    const trigger = getActiveTrigger(wrapper);
    if (!trigger || !modal) return;

    const triggerRect = trigger.getBoundingClientRect();
    const modalHeight = modal.offsetHeight || 300;
    const modalWidth = modal.offsetWidth || 280;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const padding = 12;
    const gap = 10;

    if (
      triggerRect.bottom <= 0
      || triggerRect.top >= viewportHeight
      || triggerRect.right <= 0
      || triggerRect.left >= viewportWidth
    ) {
      close(wrapper);
      return;
    }

    const spaceAbove = triggerRect.top - padding;
    const spaceBelow = viewportHeight - triggerRect.bottom - padding;
    const fitsAbove = spaceAbove >= modalHeight + gap;
    const fitsBelow = spaceBelow >= modalHeight + gap;

    let top;
    if (fitsBelow && fitsAbove) {
      top = spaceBelow >= spaceAbove
        ? triggerRect.bottom + gap
        : triggerRect.top - modalHeight - gap;
    } else if (fitsBelow) {
      top = triggerRect.bottom + gap;
    } else if (fitsAbove) {
      top = triggerRect.top - modalHeight - gap;
    } else {
      if (spaceBelow >= spaceAbove) {
        top = Math.min(
          viewportHeight - padding - modalHeight,
          Math.max(padding, triggerRect.bottom + gap)
        );
      } else {
        top = Math.max(
          padding,
          Math.min(triggerRect.top - modalHeight - gap, viewportHeight - padding - modalHeight)
        );
      }
    }

    top = Math.min(Math.max(top, padding), viewportHeight - padding - modalHeight);

    let left = triggerRect.left + ((triggerRect.width - modalWidth) / 2);

    if (left + modalWidth > viewportWidth - padding) {
      left = viewportWidth - padding - modalWidth;
    }

    if (left < padding) {
      left = padding;
    }

    // Portaled modal uses position:fixed; coordinates are viewport-relative (do not add scroll offset).
    modal.style.position = 'fixed';
    modal.style.top = `${top}px`;
    modal.style.left = `${left}px`;
    modal.style.right = 'auto';
    modal.style.bottom = 'auto';
  }

  function syncPreferredMode(wrapper) {
    const mode = wrapper?.getAttribute(PREFERRED_MODE_ATTR) || 'cart';
    const primaries = getPrimaries(wrapper);
    if (primaries.length === 1) {
      syncSinglePrimaryMode(primaries[0], mode);
      return;
    }
    primaries.forEach(primary => {
      const isPreferred = primary.getAttribute('data-mm-quick-add-mode') === mode;
      primary.classList.toggle('is-preferred', isPreferred);
      primary.hidden = !isPreferred;
      primary.setAttribute('aria-hidden', isPreferred ? 'false' : 'true');
    });
  }

  function open(wrapper, preferredMode = 'cart', trigger = null) {
    if (!wrapper) return;
    const modal = getModal(wrapper);
    if (!modal) return;

    closeAll(wrapper);
    clearProcessingState(wrapper);
    wrapper.setAttribute(OPEN_ATTR, 'true');
    wrapper.setAttribute(PREFERRED_MODE_ATTR, preferredMode);
    wrapper._mmActiveTrigger = trigger || getTrigger(wrapper, preferredMode) || getTrigger(wrapper);

    if (!wrapper._mmModalRef) {
      wrapper._mmModalRef = modal;
      wrapper._mmModalOrigParent = modal.parentNode;
      modal._mmWrapper = wrapper;
      document.body.appendChild(modal);
    }

    modal.hidden = false;

    modal.style.visibility = 'hidden';
    modal.style.display = 'block';

    setExpanded(wrapper, true);
    setProductZIndex(wrapper, true);

    if (isDesktopQuickAddViewport()) {
      syncDesktopViewportListeners();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          modal.style.visibility = '';
          positionModal(wrapper, modal);
        });
      });
    } else {
      syncDesktopViewportListeners();
      const backdrop = document.createElement('div');
      backdrop.className = 'mm-quick-add__backdrop';
      backdrop.addEventListener('click', () => close(wrapper));
      document.body.insertBefore(backdrop, modal);
      wrapper._mmBackdrop = backdrop;

      modal.style.top = '';
      modal.style.left = '';
      modal.style.right = '';
      modal.style.bottom = '';
      modal.style.visibility = '';
    }

    // Reset quantities, then default to the currently selected PDP/card variant.
    modal.querySelectorAll(VARIANT_ROW_SELECTOR).forEach(row => {
      const checkbox = row.querySelector(VARIANT_CHECKBOX_SELECTOR);
      if (checkbox) checkbox.checked = false;
      setRowSelected(row, false);
    });

    const rows = Array.from(modal.querySelectorAll(VARIANT_ROW_SELECTOR));
    const preferredVariantId = getPreferredVariantId(wrapper);
    const firstRow = rows.find(row => String(row.getAttribute('data-variant-id')) === String(preferredVariantId)) || rows[0] || null;
    const firstCheckbox = firstRow ? firstRow.querySelector(VARIANT_CHECKBOX_SELECTOR) : null;
    if (firstCheckbox) {
      firstCheckbox.checked = true;
      setRowSelected(firstRow, true);
    }

    updatePrimary(wrapper);
    syncPreferredMode(wrapper);

    const focusCheckbox = modal.querySelector(VARIANT_CHECKBOX_SELECTOR);
    if (focusCheckbox && typeof focusCheckbox.focus === 'function') {
      setTimeout(() => focusCheckbox.focus(), 50);
    }
  }

  function toggle(wrapper, preferredMode = 'cart', trigger = null) {
    if (!wrapper) return;
    if (isOpen(wrapper)) close(wrapper);
    else open(wrapper, preferredMode, trigger);
  }

  function normalizeQuantity(value, min = 1, max = 99) {
    const parsed = parseInt(value, 10);
    if (Number.isNaN(parsed)) return min;
    return Math.min(Math.max(parsed, min), max);
  }

  function parseQuantityBound(value, fallback) {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) || parsed < 1 ? fallback : parsed;
  }

  function getQuantityMin(input) {
    return parseQuantityBound(input?.getAttribute('min'), 1);
  }

  function getQuantityMax(input, row = null) {
    return parseQuantityBound(
      input?.getAttribute('max') || row?.getAttribute('data-variant-max-qty'),
      99
    );
  }

  function getQuantityLimitMessage(max) {
    return `Only ${max} available for this item.`;
  }

  function isAvailabilityLimitMessage(message) {
    const normalized = String(message || '').toLowerCase();
    return (
      normalized.includes('availability') ||
      normalized.includes('available quantity') ||
      normalized.includes('maximum quantity') ||
      normalized.includes('cannot add more') ||
      normalized.includes('already in your cart')
    );
  }

  let quickAddToastTimer = null;

  function showQuickAddToast(message, type = 'error') {
    const text = String(message || '').trim() || 'Unable to add items to cart';
    const variant = ['success', 'info', 'error'].includes(type) ? type : 'error';

    if (
      window.MMRestockToggleService &&
      typeof window.MMRestockToggleService.showThemeToast === 'function'
    ) {
      window.MMRestockToggleService.showThemeToast(text, variant);
      return;
    }

    const sharedToast = document.querySelector('.wl-toast');
    if (sharedToast instanceof HTMLElement) {
      const messageEl = sharedToast.querySelector('.wl-toast-message');
      if (messageEl) {
        messageEl.textContent = text;
      }

      sharedToast.classList.remove('wl-toast--success', 'wl-toast--error', 'wl-toast--info');
      sharedToast.classList.add(`wl-toast--${variant}`);
      sharedToast.removeAttribute('hidden');
      sharedToast.setAttribute('aria-hidden', 'false');
      void sharedToast.offsetHeight;

      const dismiss = () => {
        sharedToast.setAttribute('aria-hidden', 'true');
        sharedToast.setAttribute('hidden', 'true');
        if (quickAddToastTimer) {
          window.clearTimeout(quickAddToastTimer);
          quickAddToastTimer = null;
        }
      };

      const closeBtn = sharedToast.querySelector('.wl-toast-close');
      if (closeBtn instanceof HTMLElement) {
        closeBtn.setAttribute('tabindex', '0');
        closeBtn.setAttribute('aria-hidden', 'false');
        closeBtn.onclick = dismiss;
      }

      if (quickAddToastTimer) {
        window.clearTimeout(quickAddToastTimer);
      }
      quickAddToastTimer = window.setTimeout(dismiss, QUICK_ADD_TOAST_DURATION);
      return;
    }

    const toast = document.createElement('div');
    toast.className = `wl-toast wl-toast--${variant}`;
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'polite');

    const messageEl = document.createElement('span');
    messageEl.className = 'wl-toast-message';
    messageEl.textContent = text;
    toast.appendChild(messageEl);

    document.body.appendChild(toast);
    window.setTimeout(() => toast.remove(), QUICK_ADD_TOAST_DURATION);
  }

  function showQuantityLimitToast(max) {
    showQuickAddToast(getQuantityLimitMessage(max), 'error');
  }

  function syncRowQuantity(row, { notifyExceeded = false, allowEmpty = false } = {}) {
    if (!row) return { quantity: 1, exceeded: false };

    const qtyInput = row.querySelector(QTY_INPUT_SELECTOR);
    const selected = row.classList.contains('is-selected');
    if (!qtyInput) return { quantity: 1, exceeded: false };

    const min = getQuantityMin(qtyInput);
    const max = getQuantityMax(qtyInput, row);
    const rawValue = String(qtyInput.value || '').trim();
    const parsed = parseInt(rawValue, 10);
    const exceeded = !Number.isNaN(parsed) && parsed > max;
    let quantity = normalizeQuantity(rawValue, min, max);

    qtyInput.setAttribute('min', String(min));
    qtyInput.setAttribute('max', String(max));
    row.setAttribute('data-variant-max-qty', String(max));
    qtyInput.disabled = !selected;

    if (rawValue === '' && allowEmpty) {
      quantity = min;
    } else {
      qtyInput.value = String(quantity);
    }

    const minus = row.querySelector(QTY_MINUS_SELECTOR);
    const plus = row.querySelector(QTY_PLUS_SELECTOR);
    if (minus) minus.disabled = !selected || quantity <= min;
    if (plus) plus.disabled = !selected || quantity >= max;

    if (exceeded && notifyExceeded) {
      showQuantityLimitToast(max);
    }

    return { quantity, exceeded };
  }

  function stepRowQuantity(row, delta, { notifyExceeded = false } = {}) {
    if (!row) return null;

    const input = row.querySelector(QTY_INPUT_SELECTOR);
    if (!input) return null;

    const min = getQuantityMin(input);
    const max = getQuantityMax(input, row);
    const rawNextValue = (parseInt(input.value, 10) || min) + delta;
    const nextValue = normalizeQuantity(rawNextValue, min, max);
    input.value = String(nextValue);
    syncRowQuantity(row, { notifyExceeded: notifyExceeded && rawNextValue > max });
    updatePrimary(findWrapper(row));

    return nextValue;
  }

  function setRowSelected(row, selected) {
    if (!row) return;
    row.classList.toggle('is-selected', selected);
    const qtyInput = row.querySelector(QTY_INPUT_SELECTOR);
    const qtyWrapper = row.querySelector('[data-mm-quick-add-qty]');

    if (qtyInput) {
      qtyInput.disabled = !selected;
      if (!selected) {
        qtyInput.value = '1';
      }
    }

    if (qtyWrapper) {
      qtyWrapper.setAttribute('aria-hidden', selected ? 'false' : 'true');
    }

    syncRowQuantity(row);
  }

  function resetSelections(wrapper) {
    const modal = getModal(wrapper);
    if (!modal) return;

    modal.querySelectorAll(VARIANT_ROW_SELECTOR).forEach(row => {
      const checkbox = row.querySelector(VARIANT_CHECKBOX_SELECTOR);
      if (checkbox) checkbox.checked = false;
      setRowSelected(row, false);
    });

    updatePrimary(wrapper);
  }

  function getSelectedItems(wrapper, { notifyExceeded = false } = {}) {
    const modal = getModal(wrapper);
    if (!modal) return [];

    const items = [];
    modal.querySelectorAll(VARIANT_ROW_SELECTOR).forEach(row => {
      const checkbox = row.querySelector(VARIANT_CHECKBOX_SELECTOR);
      if (!checkbox || !checkbox.checked) return;

      const variantId = row.getAttribute('data-variant-id');
      if (!variantId) return;

      const { quantity } = syncRowQuantity(row, { notifyExceeded });

      items.push({ id: variantId, quantity });
    });

    return items;
  }

  function updatePrimary(wrapper) {
    const primaries = getPrimaries(wrapper);
    if (!primaries.length) return;

    const hasSelection = getSelectedItems(wrapper).length > 0;
    primaries.forEach(primary => {
      primary.disabled = !hasSelection;
      primary.setAttribute('aria-disabled', hasSelection ? 'false' : 'true');
    });
  }

  function animateSuccess(trigger) {
    if (!trigger) return;
    const icon = trigger.querySelector('.atc-button--icon');
    trigger.classList.add('mm-atc-success');
    if (icon) {
      const original = icon.innerHTML;
      icon.innerHTML = '✓';
      setTimeout(() => {
        trigger.classList.remove('mm-atc-success');
        icon.innerHTML = original;
      }, 900);
    }
  }

  function readSelectedAddress() {
    try {
      const raw = window.sessionStorage.getItem('mmSelectedAddress');
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && Object.keys(parsed).length) return parsed;
      }
    } catch (error) {
      /* Ignore unavailable session storage or malformed address state. */
    }

    const book = window.MMAddressBook || {};
    return book.selected || null;
  }

  function buildAddressQuery(addr) {
    if (!addr) return '';
    const params = new URLSearchParams();
    const map = {
      'checkout[shipping_address][first_name]': addr.first_name || '',
      'checkout[shipping_address][last_name]': addr.last_name || '',
      'checkout[shipping_address][address1]': addr.address1 || '',
      'checkout[shipping_address][address2]': addr.address2 || '',
      'checkout[shipping_address][city]': addr.city || '',
      'checkout[shipping_address][province]': addr.province || '',
      'checkout[shipping_address][zip]': addr.zip || '',
      'checkout[shipping_address][country]': addr.country || ''
    };

    Object.keys(map).forEach(key => {
      if (map[key]) params.append(key, map[key]);
    });

    const query = params.toString();
    return query ? `?${query}` : '';
  }

  async function addItemsToCart(wrapper, items, { redirectToCheckout = false, primaryBtn = null, triggerBtn = null } = {}) {
    const trigger = triggerBtn || getTrigger(wrapper, redirectToCheckout ? 'buy' : 'cart');
    const primary = primaryBtn || (triggerBtn ? null : getPrimary(wrapper));
    const mirroredTriggers = trigger && isProductCardQuickAdd(wrapper) ? getMirroredTriggerButtons(wrapper) : [];
    const activeTriggers = mirroredTriggers.length ? mirroredTriggers : (trigger ? [trigger] : []);
    if (!items.length) return;

    activeTriggers.forEach(activeTrigger => {
      activeTrigger.classList.add('processing');
    });
    if (primary) primary.classList.add('processing');

    const productItem = wrapper.closest('.productitem, .productgrid--item');
    const imageFrame = productItem?.querySelector('.productitem--image, .product-gallery');
    const imageEl = productItem?.querySelector('.productitem--image img');
    const imageUrl = imageEl?.src || '';
    const sourceRect = getSerializedRect(imageFrame || imageEl || trigger);

    try {
      if (redirectToCheckout) {
        if (items.length !== 1) {
          throw new Error('Choose one size for Buy Now.');
        }
        if (!window.MrMapleSingleItemCheckout || typeof window.MrMapleSingleItemCheckout.start !== 'function') {
          throw new Error('Checkout is still loading. Please try again.');
        }

        await window.MrMapleSingleItemCheckout.start({
          source: 'quick-add',
          item: {
            id: items[0].id,
            quantity: items[0].quantity || 1,
            properties: items[0].properties,
            selling_plan: items[0].selling_plan,
          },
          checkoutQuery: buildAddressQuery(readSelectedAddress()),
        });
        return;
      }

      let data;

      if (window.MiniCart && typeof window.MiniCart.addItems === 'function') {
        data = await window.MiniCart.addItems(items, {
          imageUrl,
          sourceRect,
          triggerButton: trigger,
          suppressErrorToast: true,
        });
      } else {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          let message = 'Failed to add to cart';
          try {
            const error = await response.json();
            message = error.description || error.message || message;
          } catch (parseError) {
            /* Keep fallback message for non-JSON Shopify errors. */
          }
          throw new Error(message);
        }

        data = await response.json();

        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

        if (sourceRect) {
          await animateProductToCart({ imageUrl, sourceRect });
        }

        if (window.MiniCart && typeof window.MiniCart.refresh === 'function') {
          await window.MiniCart.refresh(items[0]?.id);
          if (typeof window.MiniCart.open === 'function') {
            window.MiniCart.open();
          }
        }
      }

      document.dispatchEvent(new CustomEvent('mm-quick-add:added', {
        bubbles: true,
        detail: {
          variantId: items[0]?.id,
          imageUrl,
          item: data?.payload || data
        }
      }));

      animateSuccess(trigger);
    } catch (error) {
      const message = error?.message || 'Unable to add items to cart';
      if (!isAvailabilityLimitMessage(message)) {
        console.error('Quick add error:', error);
      }
      showQuickAddToast(message, 'error');
    } finally {
      activeTriggers.forEach(activeTrigger => {
        activeTrigger.classList.remove('processing');
      });
      if (primary) primary.classList.remove('processing');
      close(wrapper, { reset: true });
    }
  }

  const quantityHoldState = {
    button: null,
    startTimer: null,
    repeatTimer: null,
    didRepeat: false,
  };
  const suppressedQuantityClicks = new WeakSet();

  function clearQuantityHold() {
    if (quantityHoldState.startTimer) {
      window.clearTimeout(quantityHoldState.startTimer);
      quantityHoldState.startTimer = null;
    }
    if (quantityHoldState.repeatTimer) {
      window.clearInterval(quantityHoldState.repeatTimer);
      quantityHoldState.repeatTimer = null;
    }
    quantityHoldState.button = null;
    quantityHoldState.didRepeat = false;
  }

  function finishQuantityHold() {
    const button = quantityHoldState.button;
    const didRepeat = quantityHoldState.didRepeat;
    clearQuantityHold();

    if (button && didRepeat && !button.disabled) {
      suppressedQuantityClicks.add(button);
    }
  }

  function startQuantityHold(button, delta) {
    if (!button || button.disabled) return;

    clearQuantityHold();
    quantityHoldState.button = button;

    const tick = () => {
      if (!button.isConnected || button.disabled) {
        finishQuantityHold();
        return;
      }

      const row = button.closest(VARIANT_ROW_SELECTOR);
      if (!row) {
        finishQuantityHold();
        return;
      }

      quantityHoldState.didRepeat = true;
      stepRowQuantity(row, delta);
    };

    quantityHoldState.startTimer = window.setTimeout(() => {
      tick();
      if (!quantityHoldState.button) return;
      quantityHoldState.repeatTimer = window.setInterval(tick, QTY_HOLD_REPEAT_DELAY);
    }, QTY_HOLD_START_DELAY);
  }

  document.addEventListener(
    'click',
    event => {
      const target = asElement(event.target);
      if (!target) return;

      const closeBtn = target.closest(CLOSE_SELECTOR);
      if (closeBtn) {
        const wrapper = findWrapper(closeBtn);
        if (!wrapper) return;
        stopHandledClick(event);
        close(wrapper);
        return;
      }

      const minusBtn = target.closest(QTY_MINUS_SELECTOR);
      if (minusBtn) {
        const row = minusBtn.closest(VARIANT_ROW_SELECTOR);
        if (!row) return;
        stopHandledClick(event);
        if (suppressedQuantityClicks.has(minusBtn)) {
          suppressedQuantityClicks.delete(minusBtn);
          return;
        }
        stepRowQuantity(row, -1);
        return;
      }

      const plusBtn = target.closest(QTY_PLUS_SELECTOR);
      if (plusBtn) {
        const row = plusBtn.closest(VARIANT_ROW_SELECTOR);
        if (!row) return;
        stopHandledClick(event);
        if (suppressedQuantityClicks.has(plusBtn)) {
          suppressedQuantityClicks.delete(plusBtn);
          return;
        }
        stepRowQuantity(row, 1, { notifyExceeded: true });
        return;
      }

      const primaryBtn = target.closest(PRIMARY_SELECTOR);
      if (primaryBtn) {
        const wrapper = findWrapper(primaryBtn);
        if (!wrapper) return;
        stopHandledClick(event);

        const items = getSelectedItems(wrapper, { notifyExceeded: true });
        if (!items.length) return;

        const mode = primaryBtn.getAttribute('data-mm-quick-add-mode') || wrapper.getAttribute('data-mm-quick-add-mode') || 'cart';
        if (mode === 'buy') {
          addItemsToCart(wrapper, items, { redirectToCheckout: true, primaryBtn });
        } else {
          addItemsToCart(wrapper, items, { redirectToCheckout: false, primaryBtn });
        }
        return;
      }

      const variantRow = target.closest(VARIANT_ROW_SELECTOR);
      if (variantRow) {
        const clickedInLabel = !!target.closest('.mm-quick-add__variant-main');
        const clickedInQty = !!target.closest('[data-mm-quick-add-qty]');
        if (!clickedInLabel && !clickedInQty) {
          const checkbox = variantRow.querySelector(VARIANT_CHECKBOX_SELECTOR);
          if (checkbox) {
            stopHandledClick(event);
            checkbox.checked = !checkbox.checked;
            setRowSelected(variantRow, checkbox.checked);
            updatePrimary(findWrapper(variantRow));
          }
          return;
        }
      }

      const trigger = target.closest(TRIGGER_SELECTOR);
      if (trigger) {
        const wrapper = trigger.closest(WRAPPER_ROOT_SELECTOR);
        if (!wrapper) return;
        stopHandledClick(event);

        const mode = trigger.getAttribute('data-mm-quick-add-trigger-mode') || 'cart';
        const hasVariants = wrapper.getAttribute('data-mm-quick-add-has-variants') === 'true';

        if (hasVariants) {
          if (isOpen(wrapper)) {
            wrapper.setAttribute(PREFERRED_MODE_ATTR, mode);
            wrapper._mmActiveTrigger = trigger;
            syncPreferredMode(wrapper);
            if (!isMobile()) {
              const modal = getModal(wrapper);
              if (modal && !modal.hidden) {
                requestAnimationFrame(() => positionModal(wrapper, modal));
              }
            }
          } else {
            toggle(wrapper, mode, trigger);
          }
          return;
        }

        const variantId = trigger.getAttribute('data-variant-id');
        if (!variantId) return;

        addItemsToCart(
          wrapper,
          [{ id: variantId, quantity: 1 }],
          {
            redirectToCheckout: mode === 'buy',
            triggerBtn: trigger
          }
        );
        return;
      }

      if (!isInsideQuickAdd(target)) {
        closeAll();
      }
    },
    true
  );

  document.addEventListener('pointerdown', event => {
    const target = asElement(event.target);
    if (!target) return;

    const minusBtn = target.closest(QTY_MINUS_SELECTOR);
    if (minusBtn) {
      startQuantityHold(minusBtn, -1);
      return;
    }

    const plusBtn = target.closest(QTY_PLUS_SELECTOR);
    if (plusBtn) {
      startQuantityHold(plusBtn, 1);
    }
  }, true);

  ['pointerup', 'pointercancel', 'pointerleave'].forEach(eventName => {
    document.addEventListener(eventName, finishQuantityHold, true);
  });

  document.addEventListener('input', event => {
    const target = asElement(event.target);
    if (!target) return;

    const qtyInput = target.closest(QTY_INPUT_SELECTOR);
    if (!qtyInput) return;

    const row = qtyInput.closest(VARIANT_ROW_SELECTOR);
    if (!row) return;

    syncRowQuantity(row, { notifyExceeded: true, allowEmpty: true });
    updatePrimary(findWrapper(qtyInput));
  });

  document.addEventListener('change', event => {
    const target = asElement(event.target);
    if (!target) return;

    const checkbox = target.closest(VARIANT_CHECKBOX_SELECTOR);
    if (checkbox) {
      const row = checkbox.closest(VARIANT_ROW_SELECTOR);
      if (!row) return;
      setRowSelected(row, checkbox.checked);
      updatePrimary(findWrapper(row));
      return;
    }

    const qtyInput = target.closest(QTY_INPUT_SELECTOR);
    if (qtyInput) {
      const row = qtyInput.closest(VARIANT_ROW_SELECTOR);
      if (row) {
        syncRowQuantity(row, { notifyExceeded: true });
      }
      updatePrimary(findWrapper(qtyInput));
    }
  });

  document.addEventListener('focusin', event => {
    const target = asElement(event.target);
    if (!target) return;
    if (target === document.body || target === document.documentElement) return;
    if (!isInsideQuickAdd(target)) closeAll();
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openWrapper = document.querySelector(`${WRAPPER_SELECTOR}[${OPEN_ATTR}="true"]`);
    closeAll();
    const trigger = getTrigger(openWrapper);
    if (trigger && typeof trigger.focus === 'function') trigger.focus();
  });

  let repositionTimeout;
  let repositionFrame = null;
  let desktopViewportListenersBound = false;

  function repositionOpenModal() {
    if (!isDesktopQuickAddViewport()) {
      syncDesktopViewportListeners();
      return;
    }

    const openWrapper = getOpenQuickAddWrapper();
    if (!openWrapper) {
      syncDesktopViewportListeners();
      return;
    }

    const modal = getModal(openWrapper);
    if (modal && !modal.hidden) {
      positionModal(openWrapper, modal);
    }
  }

  function requestOpenModalPosition() {
    if (repositionFrame) return;
    repositionFrame = requestAnimationFrame(() => {
      repositionFrame = null;
      repositionOpenModal();
    });
  }

  function handleViewportResize() {
    if (!isDesktopQuickAddViewport()) return;
    clearTimeout(repositionTimeout);
    repositionTimeout = setTimeout(() => {
      repositionOpenModal();
    }, 16);
  }

  function bindDesktopViewportListeners() {
    if (desktopViewportListenersBound) return;
    window.addEventListener('resize', handleViewportResize, { passive: true });
    window.addEventListener('scroll', requestOpenModalPosition, { passive: true });
    desktopViewportListenersBound = true;
  }

  function unbindDesktopViewportListeners() {
    if (!desktopViewportListenersBound) return;
    window.removeEventListener('resize', handleViewportResize);
    window.removeEventListener('scroll', requestOpenModalPosition);
    desktopViewportListenersBound = false;

    if (repositionFrame) {
      cancelAnimationFrame(repositionFrame);
      repositionFrame = null;
    }
    clearTimeout(repositionTimeout);
  }

  function syncDesktopViewportListeners() {
    if (isDesktopQuickAddViewport() && getOpenQuickAddWrapper()) {
      bindDesktopViewportListeners();
      return;
    }

    unbindDesktopViewportListeners();
  }

  if (desktopQuickAddMedia && typeof desktopQuickAddMedia.addEventListener === 'function') {
    desktopQuickAddMedia.addEventListener('change', syncDesktopViewportListeners);
  } else if (desktopQuickAddMedia && typeof desktopQuickAddMedia.addListener === 'function') {
    desktopQuickAddMedia.addListener(syncDesktopViewportListeners);
  } else {
    window.addEventListener('resize', syncDesktopViewportListeners, { passive: true });
  }

  syncDesktopViewportListeners();

  initializeRandomCartIcons();
})();
